// Note: Constants for the application

export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken'
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken'
export const HTTP_STATUS_BAD_REQUEST = 400
export const UPLOADED_FILES_KEY = 'uploaded_files'

// i18n
export const I18N_SINGULAR = 1
export const I18N_PLURAL = 0

// feature flags
export const FEATURE_FLAGS = {
  BNPL: 'bnpl',
  BNPL_INTEREST: 'bnpl-interest',
  COMMI_COMBO_INSTALLMENT: 'commi-combo-installment',
  COMBO_CONNECT_ENABLED_FOR_INTEGRATOR: 'combo_connect_enabled_for_integrator',
  ENABLE_DUE_DATE_CHANGE: 'enable_due_date_change',
  ENABLE_DYNAMIC_DUE_DAY: 'enable_dynamic_due_day',
  ENABLE_INSTALLATION_NEW_EXPERIENCE: 'enable_installation_inverter',
  INSTALLATION_REDIRECT_NEW_JOURNEY: 'installation_redirect_new_journey',
  ONLY_INSTALLMENT_COMBO: 'only_installment_combo',
  SHOW_COMMISSION_MONEY: 'show-commission-money',
  SHOW_SOLFACIL_PLUS_POINTS: 'show-solfacil-plus-points',
  STORE_SHOWCASE: 'store-showcase',
  SUBSCRIPTION_ENERGY: 'subscription-energy',
  ENABLE_MULTIPLE_ENERGY_ACCOUNTS: 'enable_multiple_energy_accounts',
  NEW_MOTOR: 'new_motor',
  CHANGE_BRAND_IN_MANUAL_INPUT: 'change-brand-in-manual-input',
  COMBO_REGIONAL_OFFER: 'combo_regional_offer',
  enable_sofar_installation_alert: 'enable-sofar-installation-alert',
  TEMPORARY_INSTABILITY: 'temporary_instability',
  REVALIDATION_TAB: 'revalidate_installations',
  MY_WALLET: 'my_wallet',
}

// engine pricing constants
export const ENGINE_PRICING = {
  NEW_ENGINE: 'new_engine',
  OLD_ENGINE: 'old_engine',
} as const
